import React from "react";

import S1_Header from "./S1_Header"
import Footer from "../MainPage/S2_Footer"


const Index = () => {
  return (
    <div>
        <S1_Header />

        <Footer />
    </div>
  );
};

export default Index;
